export const GET_PROFILE_ROLE_INFO = 'get_profile_role_info';
export const GET__PROFILE_ROLE_INFO_SUCCESSFUL = 'get_profile_role_info_successful';
export const GET__PROFILE_ROLE_INFO_FAILED = 'get_profile_role_info_failed';